import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store";
import { createCarouselPost } from "../../actions/carouselposts";
import { useNavigate } from "react-router-dom";
import SnackbarComponent, { SnackbarMessage } from "../../components/Snackbar";
import headerImg from "../../assets/Images/sda_header_logo-removebg-preview.png";
import { uploadImageToBackend } from "../../constants/UploadAwsImage";

const initialFormData = {
  carousel_post_title: "",
  carousel_post_start_date: "",
  carousel_post_end_date: "",
  carousel_post_body: "",
  carousel_post_image: null as File | null,
  carousel_postt_to_display: false,
};

const CreateCarouselPostForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData);

  const dispatch = useDispatch<AppDispatch>();
  const { status, error } = useSelector(
    (state: RootState) => state.carouselposts
  );

  const [snackbarMessage, setSnackbarMessage] =
    useState<SnackbarMessage | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, files, checked } = e.target;
    if (name === "carousel_post_image" && files) {
      setFormData({
        ...formData,
        [name]: files[0],
      });
    } else if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    let imageUrl = "";

    if (formData.carousel_post_image) {
      try {
        imageUrl = await uploadImageToBackend(
          formData.carousel_post_image,
          "carousel_post_image"
        );
      } catch (err) {
        console.error("Error uploading image: ", err);
        setSnackbarMessage({
          message: "Error uploading image",
          severity: "error",
        });
        return;
      }
    }

    const formattedData = {
      ...formData,
      carousel_post_start_date: new Date(formData.carousel_post_start_date)
        .toISOString()
        .split("T")[0],
      carousel_post_end_date: new Date(formData.carousel_post_end_date)
        .toISOString()
        .split("T")[0],
      carousel_post_image: imageUrl,
    };

    dispatch(createCarouselPost(formattedData)).then((response) => {
      if (response.type.includes("fulfilled")) {
        setSnackbarMessage({
          message: "Carousel post created successfully!",
          severity: "success",
        });
        setFormData(initialFormData); // Clear the form after successful submission
      } else {
        setSnackbarMessage({
          message: "Error creating carousel post",
          severity: "error",
        });
      }
    });
  };

  return (
    <div>
      <img
        src={headerImg}
        className="w-52"
        alt="Header Logo"
        onClick={() => navigate(`/`)}
      />
      <form
        onSubmit={handleSubmit}
        className="max-w-lg mx-auto p-6 bg-white shadow-md rounded-lg space-y-4 mt-20"
      >
        <h2 className="text-2xl font-semibold mb-4">Create Carousel Post</h2>
        <div>
          <label className="block text-gray-700">Post Title</label>
          <input
            type="text"
            name="carousel_post_title"
            value={formData.carousel_post_title}
            onChange={handleChange}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <div>
          <label className="block text-gray-700">Start Date</label>
          <input
            type="date"
            name="carousel_post_start_date"
            value={formData.carousel_post_start_date}
            onChange={handleChange}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <div>
          <label className="block text-gray-700">End Date</label>
          <input
            type="date"
            name="carousel_post_end_date"
            value={formData.carousel_post_end_date}
            onChange={handleChange}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <div>
          <label className="block text-gray-700">Body</label>
          <input
            name="carousel_post_body"
            value={formData.carousel_post_body}
            onChange={handleChange}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          ></input>
        </div>
        <div>
          <label className="block text-gray-700">Image</label>
          <input
            type="file"
            name="carousel_post_image"
            onChange={handleChange}
            className="mt-1 block w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 cursor-pointer focus:outline-none"
          />
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            name="carousel_postt_to_display"
            checked={formData.carousel_postt_to_display}
            onChange={handleChange}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
          />
          <label className="ml-2 block text-gray-700">To Display</label>
        </div>
        <button
          type="submit"
          className="w-full px-4 py-2 bg-indigo-600 text-white rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Create Event
        </button>
        {status === "pending" && (
          <p className="text-yellow-500">Submitting...</p>
        )}
        {status === "failed" && (
          <p className="text-red-500">
            Error: {typeof error === "object" ? JSON.stringify(error) : error}
          </p>
        )}
      </form>
      <SnackbarComponent
        snackbarMessage={snackbarMessage}
        onClose={() => setSnackbarMessage(null)}
      />
    </div>
  );
};

export default CreateCarouselPostForm;
